<template>
  <div class="contents">
    <div class="contents__inner">
      <v-card-title>Live Reports</v-card-title>
      <ul class="live">
        <li
          id="app-modal"
          class="live__item"
          v-for="item in live"
          :key="item.postId"
          @click="onSelect(item)"
        >
          <div class="live__date">
            <h3>{{ item.date }}</h3>
          </div>
          <div class="live__detail">
            <div class="live__detailLocation">{{item.title}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getAll } from "../functions/live-reports-function";

export default {
  name: "live",
  data() {
    return {
      live: [],
    };
  },
  methods: {
    getAll: async function () {
      this.live = await getAll();
    },
    onSelect: function (item) {
      this.$router.push({
        name: "liveReport",
        params: { id: item.postId.toString() },
      });
    },
  },
  computed: {
    /* eslint-disable */
    imageLength() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300px";
        case "sm":
          return "500px";
        case "md":
          return "500px";
        case "lg":
          return "600px";
        case "xl":
          return "700px";
      }
    },
  },
  mounted: function () {
    this.getAll();
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.contents {
  margin-top: 2em;
  &__inner {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }
}

.title {
  font-size: 1.3rem;
  text-transform: uppercase;
  font-family: "discoregular";
  font-weight: normal;
  letter-spacing: 0.1rem;
  margin: 0;
}

.live {
  list-style-type: none;
  padding: 0;
  margin-top: 30px;
  &__item {
    position: relative;
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: 15px;
    &:hover {
      background-color: #fceae3;
      transition: 0.3s;
    }
  }
  &__detail {
    margin-right: auto;
    text-transform: uppercase;
    font-family: "helveticaneuelight";
    font-size: 1.6rem;
  }
  &__detailTitle {
    padding: 0 0 5px 0;
  }
  &__detailLocation {
    font-size: 1.2rem;
  }
  &__imageItem {
    display: block;
    img {
      width: 100px;
      height: auto;
    }
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      pointer-events: auto;
      content: "";
      background-color: rgba(0, 0, 0, 0);
    }
  }
  &__date {
    width: 120px;
    padding-right: 22px;
    h3 {
      margin: 0;
    }
  }
}

.description {
  margin: 10px 15px 0 0;
  text-align: end;
  span {
    padding-left: 5px;
    font-size: 13px;
  }
}

@media screen and (max-width: 1024px) {
  .contents {
    &__inner {
      max-width: 680px;
    }
  }
}

@media screen and (max-width: 480px) {
  .contents {
    &__inner {
      margin: 0 30px;
    }
  }
  .v-card__title {
    padding: 10px 0;
  }
  .description {
    text-align: start;
  }
  .live {
    &__item {
      display: block;
    }
    &__date {
      width: auto;
      padding-right: 0;
      margin-bottom: 10px;
    }
    &__imageItem {
      display: flex;
      img {
        width: 70%;
        height: auto;
        margin: 0 auto;
      }
    }
  }
}

/* popup modal */
</style>
